import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { GlassCard } from './ui/GlassCard';
export function Testimonial() {
  return <section className="relative z-10 py-24 px-4" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        <GlassCard className="p-12 md:p-16 text-center relative" data-id="element-118">
          <div className="absolute top-8 left-8 opacity-10" data-id="element-119">
            <Quote className="w-24 h-24 text-white" data-id="element-120" />
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative z-10" data-id="element-121">
            <p className="text-2xl md:text-4xl font-light leading-relaxed mb-10 text-slate-100" data-id="element-122">
              "Jeucapital zrewolucjonizował sposób, w jaki zarządzamy naszymi
              subskrypcjami. Przejrzystość danych i automatyzacja pozwoliły nam
              skupić się na produkcie, a nie na fakturach."
            </p>

            <div className="flex flex-col items-center gap-4" data-id="element-123">
              <div className="w-16 h-16 rounded-full bg-slate-700 border-2 border-emerald-500/50 overflow-hidden" data-id="element-124">
                <img src="https://api.dicebear.com/7.x/avataaars/svg?seed=Jakub" alt="Jakub Wiśniewski" className="w-full h-full object-cover" data-id="element-125" />
              </div>
              <div data-id="element-126">
                <h4 className="text-lg font-bold text-white" data-id="element-127">
                  Jakub Wiśniewski
                </h4>
                <p className="text-emerald-400 text-sm" data-id="element-128">
                  Founder of Stratos Labs
                </p>
              </div>
            </div>
          </motion.div>
        </GlassCard>
      </div>
    </section>;
}